export const banInfo = {
  cities: ['HAK', 'CGO', 'HGH', 'KWE', 'SYX', 'ZUH', 'HMI', 'TNA', 'LZG', 'MIG', 'JJN', 'HRB', 'HET', 'HLD', 'LYA', 'NNG', 'TAO', 'SHE', 'XIY', 'XNT', 'YLX', 'CKG', 'HQQ', 'PVG', 'SZX', 'NKG'],
  cabins: ['V', 'N', 'A', 'U', 'T', 'R', 'P']
}

export const getBanCities = (depCode = '', cabin = '') => {
  const { cities, cabins } = banInfo
  return cities.includes(depCode) && cabins.includes(cabin)
}
